import React from "react";
import { Link } from "react-router-dom";
import { Upload, ArrowRight } from "lucide-react";

/**
 * Polished module-level empty state — used when a page has no data to render.
 *
 * Pages call this with a short informative message and (optionally) an icon
 * so users see the same shape everywhere: icon, title, one-line explanation,
 * primary CTA to the Imports page.
 */
export default function ModuleEmptyState({
  icon: Icon = Upload,
  title,
  description,
  cta = { to: "/imports", label: "Import your first CSV" },
  testid = "module-empty",
}) {
  return (
    <div className="max-w-2xl mx-auto py-16 text-center" data-testid={testid}>
      <div className="mx-auto h-14 w-14 rounded-2xl bg-orange-600/10 border border-orange-600/30 flex items-center justify-center">
        <Icon className="h-6 w-6 text-orange-500" strokeWidth={1.6} />
      </div>
      <h2
        className="mt-6 text-2xl sm:text-3xl font-semibold tracking-tight text-zinc-50"
        style={{ fontFamily: "var(--font-heading)" }}
      >
        {title}
      </h2>
      {description && (
        <p className="mt-3 text-zinc-400 max-w-lg mx-auto leading-relaxed">{description}</p>
      )}
      {cta && (
        <Link
          to={cta.to}
          data-testid={`${testid}-cta`}
          className="mt-8 inline-flex items-center gap-2 bg-orange-600 hover:bg-orange-500 text-white text-sm font-medium px-5 py-2.5 rounded-xl transition-colors"
        >
          <Upload className="h-4 w-4" /> {cta.label} <ArrowRight className="h-3.5 w-3.5" />
        </Link>
      )}
    </div>
  );
}
